import { render } from "./ErrorBoundary.vue?vue&type=template&id=cebd9560&ts=true"
import script from "./ErrorBoundary.vue?vue&type=script&lang=ts"
export * from "./ErrorBoundary.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__